import { Component, OnInit, Inject, ElementRef, ViewChild, Sanitizer } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { SolicitudService } from "../../services/solicitud.service";
import { CorreoService } from "../../services/correo.service";
import { XsMessageBoxComponent } from "../../../common/widgets/xs-message-box/xs-message-box.component";
import * as moment from "moment";
import { ContactoDetalleComponent } from '../contacto-detalle/contacto-detalle.component';
import { PlusdCommonService } from '../../services/plusd-common.service';
import { XsAppConfigService } from 'src/app/common/services/xs-app-config.service';
import { CdkAriaLive } from '@angular/cdk/a11y';
import { ArchivoService } from '../../services/archivo.service';
// import { XsBienvenidoComponent } from '../../../core/plugins/explorer/xs-bienvenido/xs-bienvenido.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppTitleService } from 'src/app/common/services/xs-app-title';
import { FormGroup, FormBuilder } from '@angular/forms';
import Swal from 'sweetalert2';

export interface parametro {
  idSolicitud: number;
  idSolicitudDetalle: number;
  opcion: string;
  subsector: string;
}

@Component({
  selector: 'app-solicitud-registro',
  templateUrl: './solicitud-registro.component.html',
  styleUrls: ['./solicitud-registro.component.css']
})
export class SolicitudRegistroComponent implements OnInit {

  solicitud: any = {};
  listaTipoPersona = [];
  listaTipoDocumento = [];
  listaSector = [];
  datosUbigeo: any = {};
  urlBase: string;

  listaEstadoSolicitud = [];
  listaDepartamento = [];
  listaProvincia = [];
  listaDistrito = [];
  estadoSolicitud: string = "";
  documentoLength: boolean = false;
  representanteLegal: boolean = false;
  nuevaBusqueda: boolean = false;
  botonNuevo: boolean = false;
  registroManual: boolean = false;
  bloquearCampo: boolean = false;

  correoPrincial: string;
  password: string = "";
  permiso: string = "";

  file: any = {};
  nombreArchivo: string;
  cargaArchivo: boolean = false;
  mostrarUbigeo: boolean = false;

  url: string = "";
  urlSafe: SafeResourceUrl;
  htmlString;
  idArchivo = 0;
  usuarioCrea = "";

  @ViewChild("formReg", {static: false}) myFormRegister: ElementRef;
  @ViewChild("formUpload", {static: true}) myFormUpload: ElementRef;
  @ViewChild("simpleInput", {static: true}) myFileInput: ElementRef;
  @ViewChild("iframeUpload", {static: true}) myIframeUpload: ElementRef;
  urlIframe: string;
  hkey: string = "";
  tiket: string = "";

  constructor(
    @Inject(MAT_DIALOG_DATA) public parametro: parametro,
    public plusdCommonService: PlusdCommonService,
    public solicitudService: SolicitudService,
    public archivoService: ArchivoService,
    public correoService: CorreoService,
    public dialogRef: MatDialogRef<SolicitudRegistroComponent>,
    public xsAppConfigService: XsAppConfigService,
    public dialog: MatDialog,
    public sanitizer: DomSanitizer,
    public appTitleService: AppTitleService
  ) {}

  ngOnInit() {
    this.consultar();
    this.bloquearCampo = true;
  }

  uploadFileAlfresco(event){
    for (let file of event.target.files) {
      this.nombreArchivo = file.name;
      const fileSizeMB = Math.round(file.size / (1024 * 200));
      if (fileSizeMB > 200) {
          this.mostrarMensajeDialog("El tamaño máximo es de 200 MB. revisa el tamaño de los archivos que intenta cargar.");
          console.log("fileSizeMB::::::::::::", fileSizeMB);
          this.myFileInput.nativeElement.value = "";
          return;
      }

      if (!(file.name.toLowerCase().includes(".pdf"))){
          this.mostrarMensajeDialog("Los formatos permitidos son .pdf, revisa el formato del archivo que intenta cargar");
          this.myFileInput.nativeElement.value = "";
          return;
      }

      let fileSize;
      if (fileSizeMB <= 0) {
          fileSize = Math.round(file.size / 1024) + ' KB'
      } else {
          fileSize = fileSizeMB + 'MB';
      }
    }
    let params = {
      opcion: this.parametro.opcion,
      pathAlfresco: 'file.path.contacto.administrado',
      idArchivo: this.idArchivo,
      tipoArchivo: "SOLICITUD",
      audCreadoPor: this.usuarioCrea
    };
   /* this.archivoService.agregarArchivo(params).then(res => {
      if (res.data.estado == null){
        this.mostrarMensajeDialog("El servicio para adjuntar el archivo no está disponible");
        this.myFileInput.nativeElement.value = "";
        this.nombreArchivo = "Archivo Cargado: " + this.solicitud.nombreArchivo;
        return;
      }
      if (res.data.estado) {
        // this.htmlString = this.sanitizer.bypassSecurityTrustHtml(res.data.archivoHtml);
        this.idArchivo = res.data.idArchivo;
        this.urlIframe = res.data.formActionURL;
        this.hkey = res.data.keyh;
        setTimeout(() => {
          this.myFormUpload.nativeElement.appendChild(this.myFormRegister.nativeElement.querySelector('input[type=file]'));
          this.myFormUpload.nativeElement.submit();
        }, 500);
      }
    });*/
  }

  iframeURL(url){
    var s = this.sanitizer.bypassSecurityTrustUrl(url);
    return s;
  }

  iframeLoaded(){
    console.log("IFRAME LOAD");
  }

  consultar() {
    this.solicitud.idSolicitud = this.parametro.idSolicitud;
    this.solicitud.idSolicitudDetalle = this.parametro.idSolicitudDetalle;
    this.urlBase = this.plusdCommonService.APPLICATION_API_HOST;
    this.solicitud.opcion = this.parametro.opcion;
    /*this.solicitudService.consultar(this.solicitud).then(res => {
      this.permiso = this.xsAppConfigService.APLICACION_PERFIL;
      this.listaTipoPersona = res.data.listaTipoPersona;
      this.listaTipoDocumento = res.data.listaTipoDocumento;
      this.listaEstadoSolicitud = res.data.listaEstadoSolicitud;
      this.listaDepartamento = res.data.listaDepartamento;
      this.solicitud = res.data.solicitud;

      this.nombreArchivo = "Archivo Cargado: " + this.solicitud.nombreArchivo;
      this.onClickDepa(this.solicitud.idDepartamento);
      this.onClickProv(this.solicitud.idProvincia);

      if (res.data.estado) {
        if (this.parametro.opcion == "MODIFICAR") {
          this.idArchivo = this.solicitud.idArchivo;
        }
        // this.loadIframe();
      }
    });*/
  }

  // loadIframe() {
  //   this.usuarioCrea = this.xsAppConfigService.APLICACION_USUARIO_WINDOWS;
  //   let params = {
  //     opcion: this.parametro.opcion,
  //     pathAlfresco: 'file.path.contacto.administrado',
  //     idArchivo: this.idArchivo,
  //     tipoArchivo: "SOLICITUD",
  //     audCreadoPor: this.usuarioCrea
  //   };
  //   this.archivoService.agregarArchivo(params).then(res => {
  //     if (res.data.estado) {
  //       this.htmlString = this.sanitizer.bypassSecurityTrustHtml(res.data.archivoHtml);
  //       this.idArchivo = res.data.idArchivo;
  //     }
  //   });
  // }

  titulo() {
    return this.appTitleService.getTitle(this.xsAppConfigService.ID_SUBSECTOR, "SOLICITUD", this.parametro.opcion);
  }

  /*---------------------------------------------------*/
  /*-----------------------EVENTOS---------------------*/
  /*---------------------------------------------------*/

  onClickPersona(event) {
    if (event == "PN") {
      this.solicitud.idTipoDocumento = "DNI";
    } else {
      this.solicitud.idTipoDocumento = "RUC";
    }
    this.solicitud.ruc = null;
    this.documentoLength = false;
  }

  generatePassword(length): string {
    var upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var digit = "0123456789";

    var alphanum = upper + digit;

    var pass = "";

    for (var i = 0; i < length; i++) {
      pass += alphanum.charAt(Math.floor(Math.random() * alphanum.length));
    }

    return pass;
  }

  /*---------------------------------------------------*/
  /*-----------------------EVENTOS---------------------*/
  /*---------------------------------------------------*/
  usuarioExiste: boolean = false;
  onClickAceptar() {
    this.solicitud.idArchivo = this.idArchivo;
    if (!this.validarCampo()) {
      return;
    }
    switch (this.parametro.opcion) {
      case "AGREGAR":
        this.solicitud.idArchivo = this.idArchivo;
        if (this.solicitud.idSolicitud == null) {
          this.solicitud.activo = '1';
         /* this.solicitudService.agregar(this.solicitud).then(res => {
            this.solicitud.idEstadoSolicitud = "1";
            if (this.solicitud.insertar && this.solicitud.idTipoPersona == "PN") {
              this.solicitud.razonSocial = this.solicitud.apellidoPaterno + " " + this.solicitud.apellidoMaterno + " " + this.solicitud.nombre;
            }
            this.sendMail();
            this.dialogRef.close({ data: null, estado: "ACEPTAR" });
          });*/
        }
        // });
        break;
      case "MODIFICAR":
      /*  this.solicitudService.usuarioExistente({usuario: this.solicitud.dni}).then(resp =>{
          if (this.solicitud.idEstadoSolicitud == "2") {
            this.password = this.generatePassword(8);
            this.solicitud.clave = this.password;
          }
          this.solicitudService.modificar(this.solicitud).then(res => {
            if (this.solicitud.idEstadoSolicitud == "2") {
              if (resp.data.usuarioExistente > 0){
                this.usuarioExiste = true;
              }
                // if (res.data.observacion == null || res.data.observacion == "null" || res.data.observacion == "") {
                this.sendMail();
                this.mostrarMensajeDialog("La cuenta se ha activado correctamente.");
                this.dialogRef.close({ data: null, estado: "ACEPTAR" });
                // } else {
                //   this.mostrarMensajeDialog(res.data.observacion);
                // }
            } else {
              this.sendMail();
              this.dialogRef.close({ data: null, estado: "ACEPTAR" });
            }
          });
        });*/
        break;
      default:
        this.mostrarMensajeDialog("Opps. Lo siento no supe que hacer con su solicitud, por favor intentalo nuevamente ;)")
        break;
    }
  }

  sendMail() {
    switch (this.solicitud.idEstadoSolicitud) {
      case "1":
        this.estadoSolicitud = "Pendiente";
        break;
      case "2":
        this.estadoSolicitud = "Aprobada";
        break;
      case "3":
        this.estadoSolicitud = "Rechazada";
        break;
      case "4":
        this.estadoSolicitud = "En Revisión";
        break;
      default:
        this.estadoSolicitud = "Pendiente";
        break;
    }

    let fullName = this.solicitud.razonSocial;
    let status = this.estadoSolicitud;
    let display = "none";
    let username = "";
    let message = "";
    let observacion = "";
    let greeting = "";
    let body = "";
    let body2 = "";
    let email = "admin@oefa.gob.pe";

    if (status == 'Aprobada') {
      display = "block"
      username = this.solicitud.usuario;
    }

    if (status == 'Rechazada') { // para mostrar la descripción de la observacion cuando la solicitud es rechazada MFC
      observacion = "<span style='font-family:arial;'>Motivo: </span>" + this.solicitud.descripcion + ".";
    }

    if (status == 'Pendiente') {
      greeting = "Estimado Administrado: " + "<b>" + fullName + "</b>";
      body = "Su solicitud, está siendo procesada. En unos momentos le enviaremos a su <br/> correo electrónico el usuario y contraseña. <p> Si no realizaste esta solicitud, por favor no consideres este correo. <p/>";
      message = this.buildMail2(greeting, body, display, username, this.password, observacion, email);
    }

    if (status == 'Aprobada' && this.usuarioExiste){
        greeting = "Estimado Administrado: " + "<b>" + fullName + "</b>";
        body = "Su solicitud a sido aprobada, para ingresar a la plataforma, utilice sus credenciales anteriores";
        message = this.buildMail2(greeting, body, display, username, this.password, observacion, email);
    }else{
      if (status == 'Rechazada' || status == 'Aprobada' || status == 'En Revisión') {
        body2 = " <span style='font-family:arial;'>Atentamente,</br> Organismo de Evaluación y Fiscalización Ambiental</span>";
        message = this.buildMail1(fullName, status, display, username, this.password, observacion, body2, email);
      }
    }


    let solicitud: any = {};
    solicitud.correoDestino = this.solicitud.correo;
    solicitud.asunto = "ESTADO DE SOLICITUD";
    solicitud.mensaje = message;
    if (this.correoPrincial != "") {
    //  this.correoService.correoAvanzado(solicitud).then(res => { });
    }
  }
  
  buildMail1(fullName, status, display, username, password, observacion, body2, email): string {
    let mail = '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml"><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8" /><title>MTPE</title></head><body id="principal" style="margin:0;padding:0;background: white;"><table align="center" bgcolor="white" cellpadding="0" cellspacing="0" style="text-align:center;padding-top: 30px;margin-bottom: 20px " width="650px"><tbody><tr><td><table align="center" bgcolor="#FFFFFF" cellpadding="0" cellspacing="0" style="font-family:Arial; font-size:12px; border: 1px solid #000" width="100%"><tbody><tr height="130" style="background-color:#eee!important;"><td height="120" style="padding:0px 60px;width:100%;"> <a href="https://www.oefa.gob.pe/" target="_blank"> <img src="https://www.oefa.gob.pe/wp-content/themes/topbusiness/resource/img/bg/oefa-logo-header.png" alt="logo" /> </a></td></tr><tr><td height="4" style="background-color:#0089C2"></td></tr><tr><td><table border="0" cellpadding="0" cellspacing="0" style="width:100%;"><tbody><tr><td height="10"></td></tr><tr><td style="padding: 10px 60px; color: #333333; font-size: 13px; text-align: left; line-height: 2"><div style="margin-bottom: 5px"> <span>Estimado Administrado:</span> <b>${fullName}</b></div><div> <span>Su solicitud, se encuentra ${status}.<br/>Para mayor información comunícate con nosotros.</span> <br/> <b>${observacion}  </b></div><div style="display: ${display};"><div> <span>Usuario de Ingreso:</span></div><div> <span>${username}</span></div><div> <span>Contraseña de Ingreso:</span></div><div> <span>${password}</span><br><p>${body2}</p></div></div></td></tr><tr><td height="10"></td></tr><tr><table align="center" bgcolor="#999999" cellpadding="0" cellspacing="0" style="border-top: 4px solid #0089C2; background: #eee;padding:10px 0; height: 120px;" width="100%" ><tbody style="vertical-align:middle"><tr ><td height="65" width="60"></td><td align="left"><div style="font-size: 9px;"> <b style="font-size: 15px;">Correos de consultas</b> <br/><br/> <span>Atención al Administrado: <a href="mailto:${email}">${email}</a></span> <br/> <span>Ayuda Informática: <a href="mailto:soporte@oefa.gob.pe">soporte@oefa.gob.pe</a></span> <br/> <span>Webmaster: <a href="mailto:webmaster@oefa.gob.pe">webmaster@oefa.gob.pe</a></span> <br/><br/></div></td><td><div style="width:1px;height:80px; background-color:transparent"></div></td><td align="left" style="padding-left:25px;"><div style="font-size: 10px;"> <b style="font-size: 15px;">Contáctenos</b> <br/><br/> <span> Central: 204-9900 <br> Atención al Administrado: 204-9900 – Anexo: 7361<br> Ayuda Informática: 204-6000 / 204-6544 / 204-6545 </span> <br/><br/> <span> Avenida Faustino Sánchez Carrión<br> N° 603, 607 y 615 - Jesús María<br> Horario de Atención al Público:<br> Lunes a viernes 8:45 a 16:45<br> </span></div></td></tr></tbody></table></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></body></html>';
    var res = mail.replace("${fullName}", fullName);
    var res = res.replace("${status}", status);
    var res = res.replace("${display}", display);
    var res = res.replace("${username}", username);
    var res = res.replace("${password}", password);
    var res = res.replace("${observacion}", observacion); // MFC
    var res = res.replace("${body2}", body2);
    var res = res.replace("${email}", email);
    var res = res.replace("${email}", email);
    return res;
  }

  buildMail2(greeting, body, display, username, password, observacion, email): string {
    let mail = '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml"><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8" /><title>MTPE</title></head><body id="principal" style="margin:0;padding:0;background: white;"><table align="center" bgcolor="white" cellpadding="0" cellspacing="0" style="text-align:center;padding-top: 30px;margin-bottom: 20px " width="650px"><tbody><tr><td><table align="center" bgcolor="#FFFFFF" cellpadding="0" cellspacing="0" style="font-family:Arial; font-size:12px; border: 1px solid #000" width="100%"><tbody><tr height="130" style="background-color:#eee!important;"><td height="120" style="padding:0px 60px;width:100%;"> <a href="https://www.oefa.gob.pe/" target="_blank"> <img src="https://www.oefa.gob.pe/wp-content/themes/topbusiness/resource/img/bg/oefa-logo-header.png" alt="logo" /> </a></td></tr><tr><td height="4" style="background-color:#0089C2"></td></tr><tr><td><table border="0" cellpadding="0" cellspacing="0" style="width:100%;"><tbody><tr><td height="10"></td></tr><tr><td style="padding: 10px 60px; color: #333333; font-size: 13px; text-align: left; line-height: 2"><div style="margin-bottom: 5px"> ${greeting}</div><div> ${body} <br/> <b>${observacion}</b></div><div style="display: ${display};"><div> <span>Usuario de Ingreso: ${username}</span></div><div> <span>Contraseña de Ingreso: ${password}</span></div></div></td></tr><tr><td height="10"></td></tr><tr><table align="center" bgcolor="#999999" cellpadding="0" cellspacing="0" style="border-top: 4px solid #0089C2; background: #eee;padding:10px 0; height: 120px;" width="100%" ><tbody style="vertical-align:middle"><tr ><td height="65" width="60"></td><td align="left"><div style="font-size: 9px;"> <b style="font-size: 15px;">Correos de consultas</b> <br/><br/> <span>Atención al Administrado: <a href="mailto:${email}">${email}</a></span> <br/> <span>Ayuda Informática: <a href="mailto:soporte@oefa.gob.pe">soporte@oefa.gob.pe</a></span> <br/> <span>Webmaster: <a href="mailto:webmaster@oefa.gob.pe">webmaster@oefa.gob.pe</a></span> <br/><br/></div></td><td><div style="width:1px;height:80px; background-color:transparent"></div></td><td align="left" style="padding-left:25px;"><div style="font-size: 10px;"> <b style="font-size: 15px;">Contáctenos</b> <br/><br/> <span> Central: 204-9900 <br> Atención al Administrado: 204-9900 – Anexo: 7361<br> Ayuda Informática: 204-6000 / 204-6544 / 204-6545 </span> <br/><br/> <span> Avenida Faustino Sánchez Carrión<br> N° 603, 607 y 615 - Jesús María<br> Horario de Atención al Público:<br> Lunes a viernes 8:45 a 16:45<br> </span></div></td></tr></tbody></table></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></body></html>';
    var res = mail.replace("${greeting}", greeting);
    var res = res.replace("${body}", body);
    var res = res.replace("${display}", display);
    var res = res.replace("${username}", username);
    var res = res.replace("${password}", password);
    var res = res.replace("${observacion}", observacion); // MFC 16.09.2019
    var res = res.replace("${email}", email);
    var res = res.replace("${email}", email);
    // console.log("MAIL", res);
    return res;
  }


  onClickCancelar() {
    this.dialogRef.close({ data: null, estado: "ACEPTAR" });
  }

  numero_al_azar(minimo, maximo) {
    return Math.floor(Math.random() * (maximo - minimo + 1) + minimo);
  }

  onClickBuscar() {
  /*  this.solicitudService.obtenerAdministrado(this.solicitud).then(res => {
      this.solicitud = res.data.administrado;
      if (res.data.representanteLegal.length > 0) {
        this.solicitud.representanteLegal = res.data.representanteLegal[0].NombreCompleto;
        this.solicitud.cargo = res.data.representanteLegal[0].NombreCargo;
        this.representanteLegal = true;
      }

      if (this.solicitud.razonSocial != null && this.solicitud.razonSocial != "") {
        if (res.data.datosUbigeo != null){
          this.datosUbigeo = res.data.datosUbigeo;
          this.solicitud.idDepartamento = res.data.datosUbigeo.idDepartamento;
          this.onClickDepa(res.data.datosUbigeo.idDepartamento);
          this.onClickProv(res.data.datosUbigeo.idProvincia);
          this.mostrarUbigeo = true;
        }else{
          this.mostrarUbigeo = false;
        }
        this.nuevaBusqueda = true;
        this.botonNuevo = true;
        this.solicitud.insertar = false;
      } else {
        const dialogRef = this.dialog.open(XsMessageBoxComponent, {
          width: "400px",
          panelClass: "xs-message-box-dlg",
          data: { titulo: "SSO", mensaje: "No se encontraron registros, ¿desea registrar nueva persona?", icono: "XS_IDEA" }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result.estado == 'ACEPTAR') {
            this.nuevaSolicitud();
            this.registroManual = true;
            this.botonNuevo = true;
            this.solicitud.insertar = true;
          }
        });
      }
    });*/
  }

  onFileChanged(event) {
    if (!this.validarFile(event)) {
      this.file = null;
      this.nombreArchivo = "";
      return;
    }
    const file = event.target.files[0];
    this.file = file;
    this.nombreArchivo = "Archivo Cargado: " + event.target.files[0].name;
    this.cargaArchivo = true;
  }

  onClickBuscarNuevo() {
    this.nuevaSolicitud();
    this.solicitud.ruc = '';
    this.representanteLegal = false;
    this.nuevaBusqueda = false;
    this.mostrarUbigeo = false;
    this.botonNuevo = false;
    this.registroManual = false;
  }

  onClickDepa(event) {
   /* this.solicitudService.listarProvincia({ idDepartamento: event }).then(res => {
      this.listaProvincia = res.data.listaProvincia;
      if (this.parametro.opcion == "AGREGAR") {
        this.solicitud.idProvincia = this.datosUbigeo.idProvincia;
      }
    });*/
  }

  onClickProv(event) {
   /* this.solicitudService.listarDistrito({ idProvincia: event }).then(res => {
      this.listaDistrito = res.data.listaDistrito;
      if (this.parametro.opcion == "AGREGAR") {
        this.solicitud.idDistrito = this.datosUbigeo.idDistrito;
      }
    });*/
  }

  /*---------------------------------------------------*/
  /*-----------------------DIALOGO---------------------*/
  /*---------------------------------------------------*/

  onlyNumberKey(event) {
    this.validar();
    if ((event.ctrlKey || event.metaKey) && event.keyCode == 86) {
      this.validar();
    }
    // return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }

  validar() {
    if (this.solicitud.ruc != "" && this.solicitud.ruc != null) {
      if (this.solicitud.idTipoPersona == 'PN') {
        if (this.solicitud.ruc.length >= 7) {
          this.documentoLength = true;
        } else {
          this.documentoLength = false;
        }
      } else {
        if (this.solicitud.ruc.length >= 10) {
          this.documentoLength = true;
        } else {
          this.documentoLength = false;
        }
      }
    }
  }

  onlyNumberKey2(event) {
    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }


  /*-------------------------------------------------------------------------*/
  /*---------------------------- DIALOGO (MODAL) ----------------------------*/
  /*-------------------------------------------------------------------------*/
  mostrarMensajeDialog(mensaje) {
    const dialogRef = this.dialog.open(XsMessageBoxComponent, {
      width: "400px",
      panelClass: "xs-message-box-dlg",
      data: { titulo: "SSO", mensaje: mensaje, icono: "XS_IDEA" }
    });
  }

  /*---------------------------------------------------*/
  /*---------------VALIDACIÓN DE CAMPOS----------------*/
  /*---------------------------------------------------*/

  validarNroDocumento() {
    var errores = "";
    if (this.solicitud.ruc == "" || this.solicitud.ruc == null) {
      errores = "<br>Ingrese el número apropiado";
    }
    if (this.solicitud.ruc != "" && this.solicitud.ruc != null) {
      if (this.solicitud.idTipoPersona == "PN") {
        if (this.solicitud.ruc.length != 8) {
          errores = "<br>El número de DNI ingresado no es correcto";
        }
      } else {
        if (this.solicitud.ruc.length != 11) {
          errores = "<br>El número de RUC ingresado no es correcto";
        }
      }
    }
    if (errores != "") {
      this.mostrarMensajeDialog(errores);
    }
    return errores == "";
  }

  nuevaSolicitud() {
    this.solicitud.razonSocial = '';
    this.solicitud.domicilio = '';
    this.solicitud.representanteLegal = '';
    this.solicitud.cargo = '';
    this.solicitud.nombre = '';
    this.solicitud.apellidoPaterno = '';
    this.solicitud.apellidoMaterno = '';
    this.solicitud.idDepartamento = '0';
    this.solicitud.idProvincia = '0';
    this.solicitud.idDistrito = '0';
    this.solicitud.idSector = '0';
    this.solicitud.idSubsector = this.parametro.subsector;
    this.representanteLegal = false;
    this.listaProvincia = [];
    this.listaDistrito = [];
  }

  validarFile(file) {
    var errores = "";
    if (this.getFileExtension(file) != "pdf") {
      errores = "<br>El archivo seleccionado no esta permitido";
    }
    if (file.target.files[0].size / 1024 > (parseInt("500") * 1024)) {
      errores = "<br>El tamaño del archivo no debe superar a los 500 MB";
    }
    if (file.target.files[0].name.length > 70) {
      errores = "<br>El nombre del archivo no debe exceder a los 70 caracteres";
    }

    if (errores != "") {
      this.mostrarMensajeDialog(errores);
    }
    return errores == "";
  }

  getFileExtension(file) {
    var filename = file.target.files[0].name;
    var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
    return ext;
  }

  validarCampo() {
    var errores = "";
    // if ((this.parametro.opcion == 'AGREGAR' && this.nombreArchivo == 'Archivo Cargado: null') || (this.parametro.opcion == 'AGREGAR' && this.nombreArchivo == "")) {
    //   errores = "<br>Adjunte carta de poder";
    // }
    if (this.solicitud.idEstadoSolicitud == '3' && (this.solicitud.descripcion == '' || this.solicitud.descripcion == null)) {
      errores = "<br>Ingrese el motivo";
    }
    if (this.solicitud.idTipoPersona=='PJ'){
      if (!this.solicitud.razonSocial){
        errores = "<br>Tiene que ingresar el razón social";
      }
    }
    if (this.solicitud.idTipoPersona=='PN'){
      if (!this.solicitud.nombre){
        errores = "<br>Ingrese nombre del solicitante";
      }
      if (!this.solicitud.apellidoPaterno){
        errores = "<br>Ingrese el apellido paterno del solicitante";
      }
      if (!this.solicitud.apellidoMaterno){
        errores = "<br>Ingrese el apellido materno del solicitante";
      }
    }

    if (!this.solicitud.idDepartamento){
      errores = "<br>Seleccione el departamento";
    }
    if (!this.solicitud.idProvincia){
      errores = "<br>Seleccione Provincia";
    }
    if (!this.solicitud.idDistrito){
      errores = "<br>Seleccione el distrito";
    }
    if (!this.solicitud.apellidoPaternoC){
      errores = "<br>Ingrese el apellido paterno del contacto";
    }
    if (!this.solicitud.apellidoMaternoC) {
      errores = "<br>Ingrese el apellido materno del contacto";
    }
    if (!this.solicitud.nombres){
      errores = "<br>Ingrese nombre del contacto";
    }
    if (!this.solicitud.correo){
      errores = "<br>Ingrese el correo";
    }
    if (!this.solicitud.dni){
      errores = "<br>Ingrese DNI del contacto";
    }

    if (errores != "") {
      this.mostrarMensajeDialog(errores);
    }
    return errores == "";
  }

  openTab(element) {
    if(element){
      console.log("Valor del elemento", element);
      let url;
      let params = {
        uiid: element,
      }
     /* this.archivoService.consultarArchivo(params).then(res => {
        if (res.data.estado) {
          url = res.data.fullUrlDownload
          window.open(url, "_blank");
        }
      });*/
    } else {
      Swal.argsToParams(['text','No se encuentra el archivo'])
    }
  }
}
